/**
 * The backend stores three values for `source` on `WidgetCustomization` /
 * `PageMeta`: `auto` (system-generated), `manual` (user-created), and
 * `regenerate` (per-page "Generate again"). For the user, `regenerate` is
 * just another manual action, so the UI exposes only two options: Auto and
 * Manual. In requests, the UI filter `manual` is expanded to
 * `["manual", "regenerate"]` so the backend includes both sources.
 *
 * For display, callers compare `source === "auto"` directly — anything
 * else (including `regenerate`) is shown as Manual.
 */

export type UiSource = "auto" | "manual";

export type ApiSource = "auto" | "manual" | "regenerate";

/** Backend `source` values captured by the UI "Manual" filter. */
const MANUAL_API_SOURCES: ApiSource[] = ["manual", "regenerate"];

/** List of backend `source` values matching the current UI filter. */
export const expandSourceFilter = (
  filter: UiSource | undefined,
): ApiSource[] | undefined => {
  if (!filter) return undefined;

  return filter === "auto" ? ["auto"] : [...MANUAL_API_SOURCES];
};
